<script>
import TableList from '@/components/TableList.vue'
import * as components from './TableList/'
export default {
  extends: TableList,
  components
}
</script>
<style lang="scss">
.table-list.design,
.table-list.group-design {
  .column-design {
    position: relative;
    .column-design-inner {
      padding: 15px;
      display: flex;
      flex-wrap: wrap;
      .design-title {
        font-weight: bold;
        margin-bottom: 10px;
        width: 100%;
      }
      .design-thumbnail {
        width: 200px;
        height: 200px;
        float: left;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .design-main {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        label {
          margin-right: 5px;
        }
      }
      .design-summary {
        width: 250px;
        margin-right: 20px;
      }

      .design-meta {
        min-width: 250px;
        p {
          margin-bottom: 0;
        }
        ul li {
          white-space: pre-line;
        }
      }
    }
  }
}
.flag-design {
  padding: 4px 10px;
  border: 1px dashed #00b91f;
  color: #00b91f;
  margin-left: 5px;
  border-radius: var(--border-radius, 0.25rem);
  background: #e9ffec;
  cursor: pointer;
  user-select: none;
  display: none;
  &.has_design {
    display: inline-block;
  }
  i {
    font-size: 16px;
  }
}
.design-history-form {
  .description {
    .date-time {
      br {
        display: none !important;
      }
    }
    .item {
      font-weight: normal !important;
    }
  }
  .list-blueprint {
    margin: 0;
    ul {
      padding: 0;
      list-style: none;
    }
    li {
      padding: 0;
      margin: 0;
      background: 0;
      border-radius: 0;
      text-transform: none;
      font-weight: normal;
      text-decoration: none;
      &:hover a:after {
        display: none;
      }
    }
  }
}
</style>
